import React from 'react';
import ResourceDetailHeader from 'js/components/ResourceDetailHeader/ResourceDetailHeader';
import { updateApiKey } from 'js/actions';
import { Stack } from 'new/elements/Stack';
import LightningStatus from 'new/elements/LightningStatus';
import { CARD_TYPE_API_KEY } from 'js/constants/cardTypes';
import APIKeyDetailActionsContainer from 'js/components/apiKeys/cards/APIKeyDetailActionsContainer';
import styles from './APIKeyDetailHeader.module.scss';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import useAppDispatch from 'js/hooks/useAppDispatch';

interface APIKeyDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  data: any;
  isEditable: any;
  isDetected: boolean;
  disableEditMessage: any;
  isManaged: any;
  connectionOrVendorType: any;
  statsContentView: any;
  showPipelineButton?: boolean;
  showTransform?: boolean;
  showSend?: boolean;
}

const Connection = ResourceDetailHeader.TopContent.Connection;

export const APIKeyDetailHeader = (props: APIKeyDetailHeaderProps) => {
  const { readOnly, adminAccess, data, isDetected, statsContentView } = props;
  const dispatch = useAppDispatch();

  const updateInfo = (id, info) => {
    dispatch(updateApiKey(data.id, info));
  };

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      updateInfo={updateInfo}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            <Connection resourceType={CARD_TYPE_API_KEY} data={{ ...data, isDetected }} />
            <ChipWithCopy tooltipTitle="Copy API Key ID" toCopy={data.id}>
              ID {data.id}
            </ChipWithCopy>
            <div className={styles.boxInfo}>
              <LightningStatus status={data.status} />
            </div>
          </Stack>
          <Stack direction="row" alignItems="center" gap="16px">
            <APIKeyDetailActionsContainer data={data} showStatus={false} hideMenuDetails={true} />
          </Stack>
        </Stack>
      </ResourceDetailHeader.TopContent>
      {statsContentView}
    </ResourceDetailHeader>
  );
};
